import React from "react";

interface InvestorMemberProps {
    name: string;
    imageUrl: string;
}

const TeamMember: React.FC<InvestorMemberProps> = ({ name, imageUrl }) => (
    <div className="flex flex-col items-center mb-6">
        <div className="w-36 h-36 sm:w-[220px] sm:h-[220px] md:w-[260px] md:h-[260px] rounded-full mb-4 overflow-hidden">
            <img 
                src={imageUrl} 
                alt={name} 
                className="w-full h-full object-cover"
                id="investor-img"
            />
        </div>
        <div className="text-center">
            <h3 id="investor-name" className="font-semibold md:text-lg text-sm text-white">{name}</h3>
        </div>
    </div>
);

const IncredInvestor: React.FC = () => {
    const InvestorMembers: InvestorMemberProps[] = [
        {
            name: "Preetam Pathak",
            imageUrl: `${process.env.ICM_PUBLIC_ASSETS_URL}images/webp/Preetam.webp`,
        },
        {
            name: "Soumya Mittal",
            imageUrl: `${process.env.ICM_PUBLIC_ASSETS_URL}images/webp/Saumya.webp`,
        },
        {
            name: "Akshat Shrivastava",
            imageUrl: `${process.env.ICM_PUBLIC_ASSETS_URL}images/webp/Akshat.webp`,
        },
    ];
    
    return (
        <div className="bg-muted-blue-200 md:bg-muted-blue-200">
            <div className="container mx-auto">
                <div className="flex flex-col items-center justify-center align-middle md:mt-20">
                    <div className="flex flex-col px-4 sm:px-10 md:px-36 w-full pt-[32px] pb-[54px]">
                        <h2 id="investor-heading" className="mb-8 text-4xl sm:text-5xl md:text-6xl font-semibold text-center text-white">
                            Our Investors
                        </h2>
                        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8 justify-center">
                            {InvestorMembers.map((member, index) => (
                                <TeamMember key={index} name={member.name} imageUrl={member.imageUrl} />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IncredInvestor;